import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
    return (
        <footer className="relative border-t border-white/5 bg-slate-900" data-testid="site-footer">
            <div className="absolute inset-0 bg-grid bg-grid-fade opacity-30 pointer-events-none" />
            <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
                    <div className="md:col-span-5">
                        <Logo className="mb-6" />
                        <p className="text-slate-400 text-sm leading-relaxed max-w-sm">
                            A full-service MEP engineering design firm delivering precision-engineered
                            systems — 24/7 production, world-class talent, best-in-class pricing.
                        </p>
                        <div className="mt-8 flex items-center gap-3">
                            <a href="#" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-blue-500/20 hover:border-blue-500/40 transition-colors" data-testid="social-linkedin">
                                <Linkedin className="w-4 h-4 text-slate-300" />
                            </a>
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-xs font-bold tracking-[0.2em] uppercase text-cyan-400 mb-5">Navigate</div>
                        <ul className="flex flex-col gap-3 text-sm">
                            <li><Link to="/about" className="text-slate-300 hover:text-white transition-colors">About Us</Link></li>
                            <li><Link to="/services" className="text-slate-300 hover:text-white transition-colors">MEP Services</Link></li>
                            <li><Link to="/industries" className="text-slate-300 hover:text-white transition-colors">Industries</Link></li>
                            <li><Link to="/projects" className="text-slate-300 hover:text-white transition-colors">Projects</Link></li>
                            <li><Link to="/contact" className="text-slate-300 hover:text-white transition-colors">Contact</Link></li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="text-xs font-bold tracking-[0.2em] uppercase text-cyan-400 mb-5">Get in Touch</div>
                        <ul className="flex flex-col gap-4 text-sm">
                            <li className="flex items-start gap-3 text-slate-300">
                                <Mail className="w-4 h-4 mt-0.5 text-blue-400" />
                                <span>contact@pes-mep.com</span>
                            </li>
                            <li className="flex items-start gap-3 text-slate-300">
                                <Phone className="w-4 h-4 mt-0.5 text-blue-400" />
                                <span>+1 (713) 555-7740</span>
                            </li>
                            <li className="flex items-start gap-3 text-slate-300">
                                <MapPin className="w-4 h-4 mt-0.5 text-blue-400" />
                                <span>3730 Kirby Drive, Greenway / Upper<br />Houston, Texas 77098</span>
                            </li>
                        </ul>
                        <Link
                            to="/contact"
                            className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-white group"
                            data-testid="footer-start-project"
                        >
                            Start a project
                            <ArrowUpRight className="w-4 h-4 text-cyan-400 transition-transform group-hover:rotate-45" />
                        </Link>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                    <p className="text-xs text-slate-500 tracking-wider">
                        © {new Date().getFullYear()} Professional Engineering Solutions. All rights reserved.
                    </p>
                    <p className="font-mono text-[10px] text-slate-600 tracking-wider">
                        LAT 29.7384° N · LON 95.4206° W
                    </p>
                </div>
            </div>
        </footer>
    );
}
